import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.facilities');
import { OnInit, Input, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { FACILITY_TYPE_LABELS, FACILITY_TYPE_STYLES } from '../@constants';

declare let wiz: any;

@Component({
    selector: 'wiz-component-project-facilities',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.project.facilities/view.scss */
:host {
  display: block;
}`],
})
export class ComponentProjectFacilitiesComponent implements OnInit {
    @Input() facilities: any[] = [];
    @Input() projectId: string = '';
    @Output() onAdd = new EventEmitter<void>();
    @Output() onDelete = new EventEmitter<any>();
    @Output() onDownload = new EventEmitter<any>();

    public showDetailModal: boolean = false;
    public selectedFacility: any = null;
    public linkedDrawings: any[] = [];
    public detailTab: string = 'info';

    // 체크리스트 관련
    public linkedChecklists: any[] = [];
    public publishedChecklists: any[] = [];
    public showChecklistPicker: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() { }

    public openAddModal(): void {
        this.onAdd.emit();
    }

    public async deleteItem(event: Event, facility: any): Promise<void> {
        event.stopPropagation();
        const confirmed = await this.service.alert.show({
            title: '삭제 확인',
            message: '이 시설물을 삭제하시겠습니까?',
            status: 'warning',
            action: '삭제',
            actionBtn: 'danger',
            cancel: '취소'
        });
        if (!confirmed) return;
        this.onDelete.emit(facility);
    }

    public async openDetail(facility: any): Promise<void> {
        this.selectedFacility = facility;
        this.linkedDrawings = [];
        this.linkedChecklists = [];
        this.detailTab = 'info';
        this.showDetailModal = true;
        this.showChecklistPicker = false;
        await this.service.render();

        const { code, data } = await wiz.call('get_facility_detail', { id: facility.id });
        if (code === 200) {
            this.linkedDrawings = data.drawings || [];
            this.linkedChecklists = data.checklists || [];
            await this.service.render();
        }
    }

    public async closeDetail(): Promise<void> {
        this.showDetailModal = false;
        this.selectedFacility = null;
        this.linkedDrawings = [];
        this.linkedChecklists = [];
        this.showChecklistPicker = false;
        await this.service.render();
    }

    public downloadDrawing(drawing: any): void {
        this.onDownload.emit(drawing);
    }

    public isPdf(drawing: any): boolean {
        const filename = drawing?.filename || drawing?.filepath || '';
        return filename.toLowerCase().endsWith('.pdf');
    }

    public formatFileSize(bytes: number): string {
        if (!bytes) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('ko-KR', { year: 'numeric', month: 'short', day: 'numeric' });
    }

    public facilityTypeLabel(type: string): string {
        return FACILITY_TYPE_LABELS[type] || '';
    }

    public facilityTypeStyle(type: string): string {
        const style = FACILITY_TYPE_STYLES[type];
        return style ? `${style.bg} ${style.text}` : 'bg-slate-100 text-slate-500';
    }

    // ==================== 탭 전환 ====================

    public async switchTab(tab: string): Promise<void> {
        this.detailTab = tab;
        await this.service.render();
    }

    // ==================== 도면 연결 해제 ====================

    public async unlinkDrawing(drawing: any): Promise<void> {
        const confirmed = await this.service.alert.show({
            title: '도면 연결 해제',
            message: `'${drawing.filename}' 도면 연결을 해제하시겠습니까?`,
            status: 'warning',
            action: '해제',
            actionBtn: 'danger',
            cancel: '취소'
        });
        if (!confirmed) return;

        const { code } = await wiz.call('unlink_drawing', {
            facility_id: this.selectedFacility.id,
            drawing_id: drawing.id
        });
        if (code === 200) {
            await this.refreshDetail();
        }
    }

    // ==================== 체크리스트 매핑 ====================

    public async openChecklistPicker(): Promise<void> {
        this.showChecklistPicker = true;
        await this.service.render();

        const { code, data } = await wiz.call('get_published_checklists');
        if (code === 200) {
            const mappedIds = new Set(this.linkedChecklists.map((c: any) => c.id));
            this.publishedChecklists = (data || []).filter((c: any) => !mappedIds.has(c.id));
        }
        await this.service.render();
    }

    public async closeChecklistPicker(): Promise<void> {
        this.showChecklistPicker = false;
        await this.service.render();
    }

    public async mapChecklist(checklist: any): Promise<void> {
        const { code } = await wiz.call('map_checklist', {
            facility_id: this.selectedFacility.id,
            checklist_id: checklist.id,
            project_id: this.projectId,
        });
        if (code === 200) {
            this.showChecklistPicker = false;
            await this.refreshDetail();
        }
    }

    public async unmapChecklist(checklist: any): Promise<void> {
        const confirmed = await this.service.alert.show({
            title: '매핑 해제',
            message: `'${checklist.title}' 체크리스트 매핑을 해제하시겠습니까?`,
            status: 'warning',
            action: '해제',
            actionBtn: 'danger',
            cancel: '취소'
        });
        if (!confirmed) return;

        const { code } = await wiz.call('unmap_checklist', { mapping_id: checklist.mapping_id });
        if (code === 200) {
            await this.refreshDetail();
        }
    }

    private async refreshDetail(): Promise<void> {
        if (!this.selectedFacility) return;
        const { code, data } = await wiz.call('get_facility_detail', { id: this.selectedFacility.id });
        if (code === 200) {
            this.linkedDrawings = data.drawings || [];
            this.linkedChecklists = data.checklists || [];
        }
        await this.service.render();
    }

    // ==================== 점검 시작/이어하기/결과보기 ====================

    public async startInspection(cl: any): Promise<void> {
        const { code, data } = await wiz.call('start_inspection', {
            facility_id: this.selectedFacility.id,
            checklist_id: cl.id,
            mapping_id: cl.mapping_id || '',
        });
        if (code === 200) {
            this.closeDetail();
            this.service.href(`/checklist/respond/${data.response_id}`);
        }
    }

    public continueInspection(cl: any): void {
        if (cl.latest_response_id) {
            this.closeDetail();
            this.service.href(`/checklist/respond/${cl.latest_response_id}`);
        }
    }

    public viewResult(cl: any): void {
        if (cl.latest_response_id) {
            this.closeDetail();
            this.service.href(`/checklist/result/${cl.latest_response_id}`);
        }
    }

    // ==================== 상태 표시 ====================

    public statusLabel(status: string): string {
        const map: any = { draft: '초안', published: '게시됨', archived: '보관' };
        return map[status] || status;
    }

    public statusColor(status: string): string {
        const map: any = {
            draft: 'bg-yellow-50 text-yellow-700',
            published: 'bg-green-50 text-green-700',
            archived: 'bg-slate-100 text-slate-500'
        };
        return map[status] || 'bg-slate-100 text-slate-500';
    }

    public responseStatusLabel(status: string): string {
        const map: any = { draft: '작성 중', submitted: '제출 완료', reviewed: '리뷰 완료' };
        return map[status] || '';
    }

    public responseStatusColor(status: string): string {
        const map: any = {
            draft: 'bg-yellow-50 text-yellow-700',
            submitted: 'bg-green-50 text-green-700',
            reviewed: 'bg-blue-50 text-blue-700',
        };
        return map[status] || 'bg-slate-100 text-slate-500';
    }

    public formTypeLabel(type: string): string {
        const map: any = { generic: '일반', inspection: '정기안전점검' };
        return map[type] || type || '일반';
    }
}

export default ComponentProjectFacilitiesComponent;